import React, { Fragment,useState,useEffect , useReducer } from "react";
import { Button, Modal } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import { useParams } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";

const Checkout = () => {
const { id } = useParams();
const [deposit, setDeposit] = useState([]);
  const [copied, setCopied] = useState(false);


useEffect(()=>{
const data = {
  key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
  payment_id:id,
  }
  axios.post('/apps-deposit-get',data)
  .then(response=>{
     setDeposit(response.data.data)
   })
 .catch(error=>{
   console.log(error)
 })
},[id]);

const [depositInput, setDepositInput] = useState({
  amount: '',
  error_list: [],
});

const handleInput = (e) => {
  e.persist();
  setDepositInput({...depositInput, [e.target.name]: e.target.value });
}
const [showModal, setShowModal] = useState(false);
const [income, setIncome] = useState([]);
const [loading, setLoading] = useState(false);
const depositSubmit = (e) => {
  e.preventDefault();
  const auth_token = localStorage.getItem('auth_token');
  const data = {
      amount: depositInput.amount,
      key_s: 'eyJ0eXAiOiJKV1Qidfg%!#%$%LCdf#*&*JhbGciOiJSUzI1NiJ9',
      gateway_id:id,
  }
 if (auth_token !== null  && !loading) {
  setLoading(true);
 axios.post(`/apps-deposit-sub`, data).then(res => {
  setLoading(false);
         if(res.data.status === 'success')
       {
 
         setIncome(res.data.data.original)  
         setShowModal(res.data.data.original);  
         swal("Success",res.status,"success");
         setDepositInput({...depositInput,
           amount:'',
           
         });
       }
       else if(res.data.status === 'fail')
       {
         swal("Warning",res.data.message,"warning");
       }
       else 
       {
       setDepositInput({...depositInput, error_list: res.data.validation_error});
       }
       setLoading(false);
   });
 }
}
  const closeModald = () => {
    setShowModal(false);
  };
  
  const handleTextClick = () => {
    const textToCopy = showModal.sendto;
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        setCopied(true);
        // Reset copied state after 3 seconds (adjust as needed)
        setTimeout(() => setCopied(false), 3000);
      })
      .catch((error) => console.error('Unable to copy text: ', error));
  };

  const closeModal = () => {
    setShowModal(false);
  };
   return (
      <Fragment>
         <div className="row">
            <div className="col-xl-12">
               <div className="card">
                  <div className="card-body">
                     <div className="row">

                        <Modal  show={showModal} onClose={closeModal} data={income}>
                          <Modal.Header>
                          <div class="modal-title h4">Crypto Payment</div>
                            <Button variant="" className="btn-close" onClick={closeModald} type="button"></Button>
                          </Modal.Header>
                          <Modal.Body>
                              <div className="col-md-12 order-md-1">
                                <div className="row">
                                 <div className="col-md-12 mb-3 justify-content-center align-items-center" style={{ textAlign : 'center' }}>
                                    <h5> {showModal.currency} </h5>
                                    <h5> {"Total Amount " + showModal.amount} </h5>
                                    <h5 onClick={handleTextClick} style={{ cursor: 'pointer' }}>
                                      {showModal.sendto}
                                    </h5>
                                     {copied && <p>Text copied to clipboard!</p>}
                                      <img  src={showModal.img} alt="" className="me-3 rounded justify-content-center align-items-center" width={125}/>
                                </div>
                              </div>
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            
                          <Button  onClick={closeModald}  variant="primary">Close</Button>
                          </Modal.Footer>
                        </Modal>

                        <div className="col-md-4 order-md-2 mb-4">
                           <h4 className="d-flex justify-content-between align-items-center mb-3">
                              <span className="text-muted">Deposit Balance</span>
                              <span className="badge badge-primary badge-pill">
                                  {deposit.currency_symbols}
                              </span>
                           </h4>
                           <ul className="list-group mb-3">
                              <li className="list-group-item d-flex justify-content-between lh-condensed">
                                 <div>
                                    <h6 className="my-0">{deposit.Payment_name}</h6>
                                    <small className="text-muted">
                                       {deposit.Payment_name} payment
                                    </small>
                                 </div>
                                 <span className="text-muted">100%</span>
                              </li>
                              <li className="list-group-item d-flex justify-content-between lh-condensed">
                                 <div>
                                    <h6 className="my-0">Time Limit</h6>
                                    <small className="text-muted">
                                       30 Minutes 
                                    </small>
                                 </div>
                                 <span className="text-muted">30M</span>
                              </li>
                              <li className="list-group-item d-flex justify-content-between lh-condensed">
                                 <div>
                                    <small className="text-muted">
                                       Deposit Limit
                                    </small>
                                    <h6 className="my-0">Min: {deposit.currency_name} {deposit.min_amount} And Max  {deposit.currency_name} { deposit.max_amount} </h6>
                                 </div>
                              </li>
                              <li className="list-group-item d-flex justify-content-between lh-condensed">
                                 <div>
                                    <small className="text-muted">
                                       {deposit.Payment_name} payment
                                    </small>                                 
                                    <h6 className="my-0">{deposit.Payment_details}</h6>

                                 </div>
                              </li>
                           </ul>
                        </div>
                        <div className="col-md-8 order-md-1">
                           <h4 className="mb-3">Deposit Balance</h4>
                           <form onSubmit={depositSubmit} className="needs-validation" noValidate="">
                              <div className="row">
                                 <div className="col-md-12 mb-3">
                                    <label htmlFor="lastName">Amount</label>
                                    <input
                                       type="text"
                                       className="form-control"
                                       id="lastName"
                                       placeholder={"Type "+ deposit.currency_name + " Amount " + " ( " + deposit.currency_symbols + " )"}
                                       required
                                       name="amount"
                                       pattern="[0-9]+(\.[0-9]+)?"
                                       onChange={handleInput} 
                                       value={depositInput.amount}
                                    />
                                       <span className="text-danger">{depositInput.error_list.amount}</span>
                                 </div>

                              </div>

                              <hr className="mb-4" />
                              <div className="form-check custom-checkbox mb-2">
                                 <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="same-address"
                                    required

                                 />
                                 <label
                                    className="form-check-label"
                                    htmlFor="same-address"
                                 >
                                    Accept treams & condition
                                 </label>
                              </div>
                              <hr className="mb-4" />


                              <button
                                 className="btn btn-warning btn-lg btn-block"
                                 type="submit"
                                 disabled={loading}
                              >
                              {loading ? 'Loading...' : 'Continue to Deposit'}
                              </button>







                           </form>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </Fragment>
   );
};

export default Checkout;
